import React, { useState } from "react";
import { createEmptyNodeInput, StringValueType, TextInputUtils } from "api-sdk";
import { ChatReaderComponentProps } from "../types";
import { TextInputConstraints } from "reader-common";

export function TextInput(props: ChatReaderComponentProps<"TEXT">) {

    const [ inputText, setInputText ] = useState(props.value?.text || "")

    const inputLabel = props.inputField.label || props.config.messages.inputText

    const fieldType = props.inputField.stringValueType

    function handleInputChanged(text: string) {
        setInputText(text)

        // Check valid input
        props.onChange(
            text
                ? TextInputUtils.asNodeInput(TextInputUtils.cleanInput(text, props.inputField.stringValueType))
                : createEmptyNodeInput()
        )
    }

    const inputElementProps = {
        autoFocus: !!props.autoFocus,
        value: inputText,
        placeholder: inputLabel,
        title: inputLabel,
        type:  {
            [StringValueType.EMAIL]: "email",
            [StringValueType.PHONE_NUMBER]: "tel"
        }[props.inputField.stringValueType] || "text",
        onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => handleInputChanged(e.target.value || "")
    }

    const isTextArea = TextInputUtils.shouldAllowMultilineText(props.inputField)
    const inputType = fieldType === "EMAIL" ? "email" : fieldType === "PHONE_NUMBER" ? "tel" : "text"

    const inputComponent = isTextArea ? (
        <textarea { ...inputElementProps } />
    ) : (
        <input 
            { ...inputElementProps }
            inputMode={ inputType }
            name={ inputType }
        />
    )

    return (
        <div className={ "text-input chat-surface input-target text-" + (isTextArea ? "area" : "field") }>
            { inputComponent }
            <TextInputConstraints
                field={ props.inputField }
                inputText={ inputText }
                config={ props.config }
            />
        </div>
    )

}